import { z } from 'zod';

export type RegistrationStatus = z.output<typeof registrationStatusSchema>;
export type RegistrationStatusDTO = z.input<typeof registrationStatusSchema>;

export const registrationStatusSchema = z.object({
  isRegistered: z.boolean(),
  needsConfirmation: z.boolean(),
});
